<template>
    <div class="center_branch_add">
        <center-add-title>{{$t("message.cbranch.addTitle")}}</center-add-title>
        <slot name="addForm">
        </slot>
    </div>
</template>

<script>
export default {
    components: {
        centerAddTitle: () => import("@/components/center/centerAddTitle")
    }
}
</script>

<style scoped>
.center_branch_add{
    margin-top: 30px;
    padding-bottom: 20px;
    background: #fff;
}
</style>
